// extracted by mini-css-extract-plugin
export default {"content":"_3EUsPCzG2mlwHIwWs26tnA"};